<ng-container *ngIf="displayLayout(); then showLogo; else notShowLogo"></ng-container>
<ng-template #showLogo>
	<section class="uk-section uk-position-relative" uk-height-viewport>
		<div class="uk-container uk-container-xsmall uk-flex uk-flex-center">
			<div class="uk-text-center uk-width-1-2@s uk-border-rounded uk-overflow-hidden">
				<div class="uk-padding header">
					<img src="/assets/images/logo-insure.png" alt="TISCO Insure" width="220" *ngIf="theme() === 'insure'">
					<img src="/assets/images/logo-ford-insure.png" alt="Ford Ensure" width="220"
						*ngIf="theme() === 'ford'">
					<img src="/assets/images/logo-mazda-insure.png" alt="Mazda Premium Insurance" width="220"
						*ngIf="theme() === 'mazda'">
					<img src="/assets/images/logo-nissan-insure.png" alt="Nissan Premium Protection" width="220"
						*ngIf="theme() === 'nissan'">
					<img src="/assets/images/logo-gwm2.png" alt="GWM Smart Drive" width="220"
						*ngIf="theme() === 'gwm'">
				</div>
                <div class="uk-container uk-container-small">
                    <div class="uk-card uk uk-card-body">
                        <div class="loader">Loading...</div>
                    </div>
                </div>
			</div>
		</div>
		<div class="uk-position-bottom-center uk-padding-small">
			<small class="uk-text-middle">© สงวนลิขสิทธิ์ 2562 บริษัท ทิสโก้ อินชัวรันส์ โซลูชั่น จำกัด</small>
		</div>
		<app-loader *ngIf="(loader | async)"></app-loader>
	</section>
</ng-template>
<ng-template #notShowLogo>
	<router-outlet></router-outlet>
	<div class="uk-position-bottom-center uk-padding-small">
		<small class="uk-text-middle">© สงวนลิขสิทธิ์ 2562 บริษัท ทิสโก้ อินชัวรันส์ โซลูชั่น จำกัด</small>
	</div>
	<app-loader *ngIf="(loader | async)"></app-loader>
</ng-template>